import {
    OPEN_CONFIRM_DIALOG,
    SUBMIT_UNIT_SUCCESS,
    SUBMIT_UNIT_FAILED
 } from '../actions/types'


const INITIAL_STATE = {
    open_dialog: false,
    show_loading: false,
    submit_success: false,
    confirm_data: {}
}

// {
//     "code": 200,
//     "message": "Successful",
//     "payload": {
//         "confirmation_number": "CL-0258-S",
//         "floor": 1,
//         "inserted_id": "5be3508d8efad4000f4eb0cd",
//         "room_number": 103,
//         "tower": "A1"
//     }
// }

 export default (state = INITIAL_STATE, action) => {

    // console.log("---Review Unit Reducer ---")
    // console.log(action.payload)

    switch(action.type) {

        case OPEN_CONFIRM_DIALOG:
            return { ...state, open_dialog: action.payload}
            
        case SUBMIT_UNIT_SUCCESS:
            return { ...state, submit_success: true, confirm_data: action.payload, show_loading: true}
    
        case SUBMIT_UNIT_FAILED:
                return { ...state, submit_success: action.payload, show_loading: action.payload}

        default:
            return state;
    }

 }